// extracted by mini-css-extract-plugin
export default {"loginButton":"LoginButton_loginButton__b2zUj","person":"LoginButton_person__YQ87F"};